export default __webpack_public_path__ + "static/media/blue_audio.2ba8666d.mp3";